// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"8d6acb93","138":"020f715b","191":"76ec0fb5","217":"77132fbb","272":"a3e4f1d7","283":"b9b39fc7","371":"230d304c","597":"1a9adbc0","720":"98c64d30","756":"68592d6b","896":"355c1bad","970":"2b537734"}[chunkId] + ".chunk.js";
};